import React from 'react';
import {FaAddressCard, FaCalendar} from "react-icons/fa";
import {FaLocationPin, FaPersonDress} from "react-icons/fa6";
import {calculateAge} from "../../utils.js";
import projectUtils from "../../../../../../../utils/project-utils.js";
import DivisorItem from "./divisor-item.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";
import {getAssetPath} from "../../../../../../../utils/get-asset-path.js";
import CheckHasData from "../../check-has-data.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const IndividualDetails = ({data}) => {
    const navigate = navigateHook();

    const open = () => {
        const urlDev = `/individuals/form/${data.cpf}`
        navigate(urlDev, true);
    }

    const getBirthDate = () => {
        if (!data.dtBirth) return <CheckHasData value={data.dtBirth} />

        return (
            <>
                {calculateAge(data.dtBirth)}
                <span className={"ml-1 text-[10px]"}>({projectUtils.formatDate(data.dtBirth, 'DD/MM/YYYY')})</span>
            </>
        )
    }

    return (
        <div>
            <div className="border-top h-[200px] bg-[#f3f3f4] rounded-t-[5px]">
                <img className="m-auto h-full w-full object-contain p-1"
                     src={data?.relatedPhotoFaceId ?  `${API_KEEPER}/ged/attach/${data.relatedPhotoFaceId}` : getAssetPath("img/user.png")}
                     alt="image"/>
            </div>
            <div>
                <p className={`text-[16px] font-bold text-white p-2 bg-[#33804E] mb-0`}>{data.name}</p>
                <div className={"p-2 text-[14px]"}>
                    <DivisorItem icon={<FaAddressCard size={18}/>} text={"CPF"} value={projectUtils.formatCpfToView(data.cpf)}/>
                    <DivisorItem icon={<FaCalendar size={18}/>} text={"Nascimento"} value={getBirthDate()}/>
                    <DivisorItem icon={<FaPersonDress size={18}/>} text={"Nome da mãe"} value={data.motherName}/>
                    <DivisorItem icon={<FaLocationPin size={18}/>} text={"Endereço"} value={data.address}/>

                    <Button onClick={open} disabled={!data.cpf}>
                        Abrir cadastro
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default IndividualDetails;